<template>
    <div class="x-field" :class="fieldClass">
        <div class="x-input" :class="{'x-input-error': !!error}">
            <label class="x-label" :class="labelClass" v-if="!!label">{{ label }}
                <slot name="label"></slot>
                <el-tooltip :content="tooltipContent"
                            effect="dark"
                            placement="top-end"
                            v-if="!!tooltipContent">
                    <i class="fa fa-info-circle"></i>
                </el-tooltip>
            </label>
            <div style="display: flex">
                <vue-number-input v-model="localValue"
                                  :min="min"
                                  :max="numberMax"
                                  :step="step"
                                  :controls="controls"
                                  :placeholder="placeholder"
                                  @change="onChange"
                />
            </div>
            <small v-if="textError !== ''" class="x-label-error" v-text="textError"></small>
        </div>
    </div>
</template>

<script>
import XButtonIcon from "./XButtonIcon.vue"
import VueNumberInput from '@chenfengyuan/vue-number-input'

export default {
    name: 'XInputNumber',
    components: {XButtonIcon, VueNumberInput},
    props: {
        value: {
            type: String | Number,
            required: true,
        },
        type: {
            type: String,
            default: 'text'
        },
        label: {
            type: String,
            default: null,
        },
        placeholder: {
            type: String,
            default: null,
        },
        min: {
            type: Number,
            default: 0,
        },
        max: {
            default: 1000000000,
        },
        step: {
            type: Number,
            default: 1,
        },
        controls: {
            type: Boolean,
            default: true,
        },
        error: {
            default: null,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        center: {
            type: Boolean,
            default: false,
        },
        tooltipContent: {
            type: String,
            default: null,
        },
        textPrepend: {
            type: String,
            default: null,
        },
        labelClass: {
            type: String,
            default: null,
        },
        fieldClass: {
            type: String,
            default: null,
        },
        showButtonNew: {
            type: Boolean,
            default: false
        },
        iconButton: {
            type: String,
            default: 'fal fa-plus',
        },
        maxlength: {
            default: 250,
        },
        isUpdating: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            currentValue: this.value,
        };
    },
    computed: {
        numberMax() {
          return Number(this.max);
        },
        textError() {
            if (!_.isNull(this.error)) {
                return this.error[0];
            }
            return '';
        },
        localValue: {
            get() {
                return this.value;
            },
            set(newValue) {
                this.$emit('input', newValue);
            },
        },
    },
    methods: {
        onChange(newValue, oldValue) {
            if (this.isUpdating) {
                return
            }
            this.$emit('change', newValue)
        },
    }
}
</script>
